import strFunc from "@/lib/lyg/string";
import TextAreaComponent from "@/pcomponents/common/crud/write/textarea";
import MultyLineTextView from "@/pcomponents/common/crud/view/multy_line_text";

function MessageListArea(props: any) {
  let myProps = {
    counsel_todo_arr: [],
    set_counsel_todo_arr: (inData: any) => { },
    check_counsel_seq_arr: [],
    set_check_counsel_seq_arr: (inData: any) => { },
    check_all_counsel: (inData: any) => { },
    Style: {} as any,
    ...props
  };
  let counsel_todo_arr = myProps.counsel_todo_arr;

  let Style = myProps.Style;

  const on_change_msg_input = (inData: any) => {
    let opt_obj = {
      name: "",
      value: "",
      idx: -1,
      ...inData
    };
    let name = opt_obj.name;
    let value = opt_obj.value;
    let idx = opt_obj.idx;
    let new_msg_arr = [...counsel_todo_arr];
    if (new_msg_arr[idx]) {
      let change_msg_row = { ...new_msg_arr[idx] };
      change_msg_row[name] = value;
      new_msg_arr[idx] = change_msg_row;
      myProps.set_counsel_todo_arr(new_msg_arr);
    }
  };

  const on_chnage_check_counsel = (inData: any) => {
    let opt_obj = {
      is_check: false,
      row_pri_val: "",
      ...inData
    };
    let is_check = opt_obj.is_check;
    let row_pri_val = opt_obj.row_pri_val;
    let tmp_arr: any = [...myProps.check_counsel_seq_arr];
    if (is_check) {
      if (strFunc.str_in_array(row_pri_val, tmp_arr) == -1) {
        tmp_arr.push(row_pri_val);
      }
    } else {
      tmp_arr = [];
      for (let i = 0; i < myProps.check_counsel_seq_arr.length; i++) {
        let val = myProps.check_counsel_seq_arr[i];
        if (val != row_pri_val) {
          tmp_arr.push(val);
        }
      }
    }
    myProps.set_check_counsel_seq_arr(tmp_arr);
  };

  const get_msg_row_tags = () => {
    let msg_tags: any = counsel_todo_arr.map((msg_row: any, idx: number) => {
      let is_checked = false;
      if (strFunc.str_in_array(msg_row.row_pri_val, myProps.check_counsel_seq_arr) != -1) {
        is_checked = true;
      }
      return (
        <div key={idx} className={Style.msg_item}>
          <label>
            <div className={Style.msg_row_header}>
              <span>
                <input type="checkbox" name="row_check_box" value="1" checked={is_checked}
                  onChange={(e: any) => {
                    on_chnage_check_counsel({
                      is_check: e.target.checked,
                      row_pri_val: msg_row.row_pri_val
                    });
                  }}
                />
              </span>
              <span className={Style.msg_num}>{idx + 1}</span>
              <span className={Style.room_label}>방이름: </span>
              <span className="ml-1">
                {msg_row.katalk_room_name}
              </span>
            </div>
          </label>
          <div className={Style.msg_textarea}>
            <MultyLineTextView
              style={{ borderRadius: "5px", background: "#fff" }}
              text={msg_row.a_content}
            ></MultyLineTextView>
          </div>
        </div>
      );
    });

    if (strFunc.is_empty(msg_tags)) {
      msg_tags = (
        <div className={Style.empty_msg}>
          <div className={Style.empty_icon}>📭</div>
          <div>메시지 내역이 없습니다.</div>
        </div>
      );
    }

    return msg_tags;
  };

  return (
    <div className={Style.msg_section}>
      <div className={Style.msg_header}>
        <h3>
          메시지 내역
          <span className={Style.msg_count}>{counsel_todo_arr.length}건</span>
        </h3>
      </div>
      <div>
        <label>
          <input type="checkbox" name="check_all_counsel" value="1"
            onChange={(e: any) => {
              myProps.check_all_counsel(e);
            }}
          /> 전체 선택
        </label>
      </div>
      <div>
        {get_msg_row_tags()}
      </div>
    </div>
  );
};
export default MessageListArea;